import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import TrmsDataGrid from './TrmsDataGrid.jsx';

const TrmsNaeyeokV3 = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() + 1000 * 60 * 60 * 9 - 1000 * 60 * 60 * 24 * 7).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchGubun: '',
        searchDateCls: '01',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: '',
    });

    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['표준등록체계상태', '외상제외대상여부', '기관명', '등록번호', '환자분류', '성명', '나이', '손상유형', '사고종류', '내원일시', '내원경로', '내원수단', '응급진료결과', '최종ISS']; //component화 
    const dataColumn = ['PTMISTATNAME', 'TRMSEXYN', 'EMOGDESC', 'PTMIMASK', 'TRMSPTGB', 'PTMINAME', 'PTMIBRTD', 'TRMSDMTP', 'TRMSACKN', 'PTMIINDTM', 'PTMIINRT', 'PTMIINMN', 'PTMIEMRT', 'TRMSCISS'];
    const apiCall = '/trmsapi/oesangweb/bdtrms_naeyoek_v3.do';
    const apiCntCall = '/trmsapi/oesangweb/bdtrms_naeyoek_v3_cnt.do';
    const excelFileName = '외상환자조회V3';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="8%" />
                        <col width="24%" />
                        <col width="6%" />
                        <col width="18%" />
                        <col width="6%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="01">내원일자</option>
                                    <option value="02">전송일자</option>
                                    <option value="03">퇴원일자</option>
                                    <option value="04">퇴실일자</option>
                                    <option value="05">수상일자</option>
                                </select>
                            </th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>구분</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    value={searchParams.searchGubun}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="C">등록</option>
                                    <option value="D">삭제</option>
                                    <option value="P">외상환자제외</option>
                                    <option value="E">연동후제외</option>
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                    className='w-full'
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>응급진료결과</th>
                            <td>
                                <div className='flex gap-3'>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck1"
                                            value=""
                                            checked={searchParams.searchCheck1 === ''}
                                            onChange={handleInputChange}
                                        />
                                        전체
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck1"
                                            value="01"
                                            checked={searchParams.searchCheck1 === '01'}
                                            onChange={handleInputChange}
                                        />
                                        귀가
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck1"
                                            value="02"
                                            checked={searchParams.searchCheck1 === '02'}
                                            onChange={handleInputChange}
                                        />
                                        전원
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck1"
                                            value="03"
                                            checked={searchParams.searchCheck1 === '03'}
                                            onChange={handleInputChange}
                                        />
                                        입원
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck1"
                                            value="04"
                                            checked={searchParams.searchCheck1 === '04'}
                                            onChange={handleInputChange}
                                        />
                                        사망
                                    </label>
                                </div>
                            </td>
                            <th>중증도</th>
                            <td colSpan={3}>
                                <div className='flex gap-3'>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck2"
                                            value=""
                                            checked={searchParams.searchCheck2 === ''}
                                            onChange={handleInputChange}
                                        />
                                        전체
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchCheck2"
                                            value="01"
                                            checked={searchParams.searchCheck2 === '01'}
                                            onChange={handleInputChange}
                                        />
                                        중증외상(ISS 15점 초과)
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <TrmsDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                ver='V3'
            />
            <div>
                <p>* 외상 제외 대상 여부: 외상등록체계 전송 이후 표준등록체계 데이터 변동으로 인한 외상등록체계 제외 대상 여부</p>
                <p className='ml-2'>- Y: 외상등록체계 전송 대상이었으나, 표준등록체계 정보가 변경되어 연동 후 제외된 건</p>
                <p className='ml-2'>- D: 외상등록체계 전송 대상이었으나, 표준등록체계에서 삭제('D' flag)된 건</p>
                <p className='ml-2'>- N: 외상등록체계 전송 이후 표준등록체계 정보가 변경되었으나, 외상등록체계 전송 대상인 건</p>
                <p className='ml-2'>- 빈칸: 외상등록체계 전송 이후 표준등록체계 정보 변경이 없는 건</p>
                <p>* '외상환자 제외' 및 '외상 삭제'인 경우라도 '연동 후 제외'인 건은 '연동 후 제외'로 조회</p>
            </div>
        </Main>
    )
}

export default TrmsNaeyeokV3;